import { Injectable } from "@angular/core";
import { PresetManagementAPI } from "src/app/api/preset-management.api";
import { CreatePresetDTO } from "src/app/model/presets/create-preset-dto.model";
import { SloPresetDTO } from "src/app/model/presets/slo-preset-dto.model";

@Injectable({
    providedIn: 'root'
})
export class PresetManagementService {


    constructor(private presetManagementAPI: PresetManagementAPI) { }

    public getPresets(publishedOnly: boolean = false) {
        return this.presetManagementAPI.getPresets(publishedOnly);
    }

    public getPreset(presetID: string) {
        return this.presetManagementAPI.getPreset(presetID);
    }

    public getSloPresets() {
        return this.presetManagementAPI.getSloPresets();
    }

    public updateSloPreset(preset: SloPresetDTO) {
        return this.presetManagementAPI.updateSloPreset(preset);
    }

    public createPreset(request: CreatePresetDTO) {
        return this.presetManagementAPI.createPreset(request);
    }

    public deletePreset(presetID: string) {
        return this.presetManagementAPI.deletePreset(presetID);
    }

    public getPresetNames() {
        return this.presetManagementAPI.getPresetNames();
    }
}